import { CircularProgress, Box, Typography } from "@mui/material";

interface LoaderWithDescriptionProps {
  title: string;
  subtitle: string;
}

export default function LoaderWithDescription({
  title,
  subtitle,
}: LoaderWithDescriptionProps): React.JSX.Element {
  return (
    <Box
      sx={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        flexDirection: "column",
        p: 4,
      }}
    >
      <CircularProgress sx={{ marginBottom: 2 }} />
      <Typography variant="h6">{title}</Typography>
      <Typography variant="caption">{subtitle}</Typography>
    </Box>
  );
}
